module.exports = __webpack_public_path__ + "img/switcher-next.005a6caf.svg";